import React, { useEffect, useState } from 'react';
import { GridView } from '@one-thd/sui-icons';
import { Typography, Link } from '@one-thd/sui-atomic-components';
import { routes } from '../constants/routes';

const AccountDashboardLink = () => {
  const [isActive, setIsActive] = useState(false);
  const activeStyles = isActive ? 'sui-pl-2 sui-bg-subtle' : '';
  const dashboardPath = routes.dashboard.path;
  const currentLocation =
    typeof window !== 'undefined' && window.location.pathname;

  useEffect(() => {
    if (currentLocation === routes.dashboard.path) {
      setIsActive(true);
    }
  }, [currentLocation]);

  return (
    <div className={`sui-mb-6 sui-py-2 sui-mt-2 ${activeStyles}`}>
      <Link
        href={dashboardPath}
        className="sui-inline-flex sui-flex-row sui-space-x-2 sui-items-center"
      >
        <GridView size="small" />
        <Typography>
          <span className="sui-underline">Account Dashboard</span>
        </Typography>
      </Link>
    </div>
  );
};

export default AccountDashboardLink;
